// frontend/src/pages/Companies/index.tsx

import React, { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import { CompanyCard } from '@/components/company/CompanyCard'
import { SearchBar } from '@/components/search/SearchBar'
import { Spinner } from '@/components/common/UI/Spinner'
import { Button } from '@/components/common/UI/Button'
import { useAuthStore } from '@/store'

const Companies: React.FC = () => {
  const { isAuthenticated, user } = useAuthStore()
  const [searchQuery, setSearchQuery] = useState('')
  const [page, setPage] = useState(1)

  const { data, isLoading, error } = useQuery({
    queryKey: ['companies', searchQuery, page],
    queryFn: async () => {
      const params: any = { page, skip: (page - 1) * 20, limit: 20 }
      if (searchQuery) {
        params.search = searchQuery
      }
      return apiClient.get('/v1/companies', { params })
    }
  })

  const handleSearch = (query: string) => {
    setSearchQuery(query)
    setPage(1)
  }

  if (isLoading && page === 1) {
    return (
      <div className="container-custom py-12 flex justify-center">
        <Spinner size="lg" />
      </div>
    )
  }

  return (
    <div className="container-custom py-8">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Компании и работодатели</h1>
        {isAuthenticated && user?.role === 'employer' && (
          <Button onClick={() => window.location.href = '/companies/create'}>
            Создать компанию
          </Button>
        )}
      </div>

      <div className="mb-6 max-w-md">
        <SearchBar
          placeholder="Поиск компаний..."
          onSearch={handleSearch}
        />
      </div>

      <p className="text-secondary-600 text-sm mb-4">
        Найдено: {data?.total || 0} компаний
      </p>

      {error ? (
        <div className="text-center py-8">
          <p className="text-error">Ошибка загрузки компаний</p>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {data?.items?.map((company: any) => (
              <CompanyCard key={company.id} company={company} />
            ))}
          </div>

          {data?.items?.length === 0 && (
            <div className="text-center py-12">
              <p className="text-secondary-500">Компаний не найдено</p>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default Companies
